import styles from "./styles/PosLogin.module.css";

import { useContext } from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../components/ui/button/Button";
import OutputWindow from "../../../components/ui/output_window/OutputWindow";
import Spinner from "../../../components/ui/spinner/Spinner";
import DataContext from "../../../context/DataContext";

const Modal = ({
    inProcess, // {Boolean} - Flag to check if the process is in progress
    errorMessage, // {String} - The error message from the server
    handleReset, // {Function} - The function to reset the form data
}) => {
    const {
        currentCustom, // {Object} - the client customizations
    } = useContext(DataContext);
    const { t } = useTranslation();

    return (
        <div
            className={`${styles.main_form_container} ${styles.window} v-flex-container`}
        >
            {/* if the data was fetched successfully and the user is not authenticated 
           show the feed back window with the error message from the server red colored 
           or if in process show a spinner in the window with theme color */}
            <div
                className={`${
                    !inProcess ? styles.output_window_container : ""
                }  v-flex-container`}
            >
                <OutputWindow
                    content={
                        inProcess ? (
                            <Spinner />
                        ) : (
                            <div
                                className={`${styles.result_text_container} v-flex-container`}
                            >
                                <h1>{t(`${errorMessage}`)}</h1>
                            </div>
                        )
                    }
                    // color in process is red and currrent theme color when not in process
                    color={
                        inProcess
                            ? currentCustom?.color?.current
                            : currentCustom?.color?.error
                    }
                />
            </div>
            {/* show the reset button only when not in process */}
            {!inProcess && (
                <div
                    className={`${styles.result_buttons_container} flex-container`}
                >
                    <Button
                        onClickFuction={handleReset}
                        body={t(`go back`)}
                        type={"button"}
                    />
                </div>
            )}
        </div>
    );
};

export default Modal;
